import { useState, useRef } from 'react'
import { Field } from 'formik';

export default function ConfirmPassword({ handleBlur, errors, touched, prefix, disabled }) {

    const [passwordType, setPasswordType] = useState("password");
    const [showTooltip, setShowTooltip] = useState(false);
    const confirmPasswordRef = useRef(null);
    
    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }

    // Handle tab key from password field to go to confirm password field
    const handlePasswordKeyDown = (e) => {
        if (e.key === 'Tab' && !e.shiftKey) {
            e.preventDefault();
            confirmPasswordRef.current?.focus();
        }
    }

    return (
        <div className="space-y-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div className="relative">
                    <div className="relative">
                        <label for="password" className='block text-sm font-medium text-gray-700 mb-1'>Password <span className="text-red-500">*</span></label>
                        <div className="relative">
                            <Field 
                                id={`${prefix}-input_password`} 
                                name="password" 
                                required
                                onBlur={handleBlur}
                                onKeyDown={handlePasswordKeyDown}
                                type={passwordType}
                                disabled={disabled}
                                className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:border-transparent pr-10 ${
                                    disabled ? 'bg-gray-100 cursor-not-allowed' : ''
                                } ${errors.password && touched.password ? 'border-red-500' : ''}`} 
                            />
                            <button
                                type="button"
                                onClick={togglePassword}
                                tabIndex="-1"
                                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                            >
                                {passwordType === "password" ?
                                    <i className="fa fa-eye text-sm"></i>
                                    :
                                    <i className="fa fa-eye-slash text-sm"></i>
                                }
                            </button>
                        </div>
                        {errors.password && touched.password ? (
                            <div className="text-red-500 text-sm mt-1">{errors.password}</div>
                        ) : null}
                    </div>
                    
                    {/* Password Requirements Tooltip */}
                    <div className="mt-2">
                        <button
                            type="button"
                            onClick={() => setShowTooltip(!showTooltip)}
                            className="text-xs text-blue-600 hover:text-blue-800 focus:outline-none underline"
                        >
                            Password Requirements
                        </button>
                        {showTooltip && (
                            <div className="mt-2 p-3 bg-gray-50 border border-gray-200 rounded-md text-sm text-gray-700">
                                <p className="font-medium mb-2">Password should be minimum 8 characters long.</p>
                                <p className="font-medium mb-1">Password should contain:</p>
                                <ul className="list-disc list-inside space-y-1 ml-2">
                                    <li>at least one upper case and one lower case character</li>
                                    <li>at least one numeric character</li>
                                    <li>at least 2 special characters</li>
                                </ul>
                            </div>
                        )}
                    </div>
                </div>

                <div>
                    <label for="confPassword" className='block text-sm font-medium text-gray-700 mb-1'>Confirm Password <span className="text-red-500">*</span></label>
                    <Field 
                        innerRef={confirmPasswordRef}
                        id={`${prefix}-input_confPassword`} 
                        name="confPassword" 
                        required
                        type={passwordType}
                        onBlur={handleBlur}
                        disabled={disabled}
                        className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:border-transparent ${
                            disabled ? 'bg-gray-100 cursor-not-allowed' : ''
                        } ${errors.confPassword && touched.confPassword ? 'border-red-500' : ''}`} 
                    />
                    {errors.confPassword && touched.confPassword ? (
                        <div className="text-red-500 text-sm mt-1">{errors.confPassword}</div>
                    ) : null}
                </div>
            </div>
        </div>
    );
}